import DocumentDetails from "../GridDataComponent/DocumentDetails";
import "../../CriminalCertificateValidation.css";

const PassBook = () =>{
 return(
   <DocumentDetails documentType={'bank-passbooks'} keyAccess={'HawkAI-BankPassbook'} title={'Bank Passbook'} exportDataToExcelName={'BankPassbook Document'} analysefrom={'bank-passbook'} deleteText={'bank-passbook'} modelName={'doc-ai'} webSocketName={'bankpassbook'}/>
 )
};
export default PassBook;